// extracted by mini-css-extract-plugin
module.exports = {"infinite-carousel":"Banners_infinite-carousel__1oScO","bannerImage":"Banners_bannerImage__1g9oF"};